import {
  html,
  android,
  figma,
  git,
  javascript,
  mongodb,
  nodejs,
  php,
  reactjs,
  swift,
  tailwind,
  css,
  threejs,
} from "../assets/images";

const SkillsData = [
  {
    name: "HTML",
    icon: html,
    proficiency: 98,
  },
  {
    name: "CSS",
    icon: css,
    proficiency: 97,
  },
  {
    name: "JavaScript",
    icon: javascript,
    proficiency: 95,
  },
  {
    name: "React JS",
    icon: reactjs,
    proficiency: 96,
  },
  {
    name: "Tailwind CSS",
    icon: tailwind,
    proficiency: 97,
  },
  {
    name: "Node JS",
    icon: nodejs,
    proficiency: 90,
  },
  {
    name: "MongoDB",
    icon: mongodb,
    proficiency: 89,
  },
  {
    name: "Three JS",
    icon: threejs,
    proficiency: 75,
  },
  {
    name: "git",
    icon: git,
    proficiency: 92,
  },
  {
    name: "figma",
    icon: figma,
    proficiency: 97,
  },
  {
    name: "php",
    icon: php,
    proficiency: 99,
  },
  {
    name: "swift",
    icon: swift,
    proficiency: 85,
  },
  {
    name: "android",
    icon: android,
    proficiency: 85,
  },
];

export {SkillsData};
